// removed by extract-text-webpack-plugin
module.exports = {"root":"IconEmailAttention__root__lSDMK","marketplaceStroke":"IconEmailAttention__marketplaceStroke__2s8Dy","attentionStroke":"IconEmailAttention__attentionStroke__353um"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconEmailAttention/IconEmailAttention.css
// module id = 1837
// module chunks = 0